import { render, staticRenderFns } from "./LoginRemindPassword.vue?vue&type=template&id=554c6234&scoped=true&"
import script from "./LoginRemindPassword.vue?vue&type=script&lang=js&"
export * from "./LoginRemindPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginRemindPassword.vue?vue&type=style&index=0&id=554c6234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c6234",
  null
  
)

export default component.exports